module.exports = __webpack_public_path__ + "img/logo-dc.2ccae4d1.svg";